import { Controller } from "stimulus"

// Shows/hides a target field depending on whether a <select> equals a given value.
// Usage: data-controller="conditionalSelect" on a wrapper containing the <select>
// (data-conditionalSelect-target="select", data-action="change->conditionalSelect#toggle")
// and the field to reveal (data-conditionalSelect-target="field").
export default class extends Controller {
  static targets = ["select", "field"]
  static values = { trigger: String }

  connect() {
    this.toggle()
  }

  toggle() {
    const shouldShow = this.selectTarget.value === this.triggerValue

    this.fieldTargets.forEach((field) => {
      field.classList.toggle("is-hidden", !shouldShow)
      field.querySelectorAll("input, textarea, select").forEach((input) => {
        input.disabled = !shouldShow
      })
    })
  }
}
